import './App.css';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Shop from './Shop';
import ProductDetail from './ProductDetail';
import Tickets from './Tickets';
import Checkout from './Checkout';
import OrderConfirmation from './OrderConfirmation';
import Events from './Events';
import About from './About';
import Gallery from './Gallery';
import Dropzone from './Dropzone';
import DropzoneAdmin from './DropzoneAdmin';
import Secret from './Secret';
import { Analytics } from '@vercel/analytics/react';

function App() {
  const [displayText, setDisplayText] = useState('');
  const [showCursor, setShowCursor] = useState(true);
  const [animationPhase, setAnimationPhase] = useState('blinking'); // 'blinking', 'typing', 'complete'
  const [, setBlinkCount] = useState(0);
  const [showMenu, setShowMenu] = useState(false);

  const text1 = "H4NDKR4FT3D P4RTI3$";
  const text2 = "[FØR 4 N3W WØRLD]";

  useEffect(() => {
    let interval;

    if (animationPhase === 'blinking') {
      // Blink cursor 2 times
      interval = setInterval(() => {
        setShowCursor(prev => !prev);
        setBlinkCount(prev => {
          if (prev >= 3) { // 2 blinks = 4 state changes
            setAnimationPhase('typing');
            return 0;
          }
          return prev + 1;
        });
      }, 500);
    } else if (animationPhase === 'typing') {
      // Start typing animation
      setShowCursor(true);
      let currentIndex = 0;
      const fullText = text1 + '\n' + text2;

      interval = setInterval(() => {
        if (currentIndex < fullText.length) {
          setDisplayText(fullText.substring(0, currentIndex + 1));
          currentIndex++;
        } else {
          clearInterval(interval);
          setShowCursor(false); // Hide cursor when typing is complete
          setAnimationPhase('complete');
          // Show menu after a short delay
          setTimeout(() => {
            setShowMenu(true);
          }, 1000);
        }
      }, 100);
    }

    return () => clearInterval(interval);
  }, [animationPhase]);

  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <div className="App">
            <div className="typing-container">
              <div className="typing-text">
                {displayText.split('\n').map((line, index) => (
                  <div key={index} className="typing-line">
                    {index === 1 && line.includes('[') ? (
                      <>
                        {line.charAt(0) === '[' && <span className="bracket">[</span>}
                        {line.length > 2 && <span className="bracket-text">{line.slice(1, -1)}</span>}
                        {line.charAt(line.length - 1) === ']' && <span className="bracket">]</span>}
                      </>
                    ) : (
                      line
                    )}
                    {index === displayText.split('\n').length - 1 && showCursor && <span className="cursor">|</span>}
                  </div>
                ))}
              </div>
            </div>

            {/* Top Menu - slides down from top */}
            <div className={`top-menu ${showMenu ? 'slide-down' : ''}`}>
              <Link to="/events" className="menu-item">EVENTS</Link>
              <Link to="/shop" className="menu-item">SHOP</Link>
              <Link to="/gallery" className="menu-item">GALLERY</Link>
            </div>

            {/* Bottom Menu - slides up from bottom */}
            <div className={`bottom-menu ${showMenu ? 'slide-up' : ''}`}>
              <Link to="/about" className="menu-item">ABOUT</Link>
              <Link to="/tickets" className="menu-item">TICKETS</Link>
              <Link to="/secret" className="menu-item">SECRET</Link>
            </div>
          </div>
        } />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product/:productId" element={<ProductDetail />} />
        <Route path="/events" element={<Events />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/dropzone" element={<Dropzone />} />
        <Route path="/admin/dropzone" element={<DropzoneAdmin />} />
        <Route path="/secret" element={<Secret />} />
        <Route path="/about" element={<About />} />
        <Route path="/tickets" element={<Tickets />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/order-confirmation" element={<OrderConfirmation />} />
      </Routes>
      <Analytics />
    </Router>
  );
}

export default App;
